import produce from 'immer';

import type { AppAction } from '@/redux/app/actions';
import { UserTypes } from '@/redux/app/actions/user';

export interface UserState {
  audio: boolean;
  snoozeUntil: string | null;
  snoozeMuteChat: boolean;
  snoozeMuteCalls: boolean;
  remindOfTcrDeadline: boolean;
  tcrBannerDismissedStep: string | null;
}

export const initialState: UserState = {
  audio: null,
  snoozeUntil: null,
  snoozeMuteChat: true,
  snoozeMuteCalls: true,
  remindOfTcrDeadline: null,
  tcrBannerDismissedStep: null,
};

const updateCallMuteState = (state: UserState) => {
  const isSnoozed = state.snoozeUntil && new Date(state.snoozeUntil) > new Date();
  if (!state.audio || (isSnoozed && state.snoozeMuteCalls)) {
    window.sharedApi.muteIncomingCalls();
  } else {
    window.sharedApi.unmuteIncomingCalls();
  }
};

export const reducer = produce((state: UserState, action: AppAction) => {
  switch (action.type) {
    case UserTypes.SET_USER: {
      state.audio = action.payload.user.audio;
      state.snoozeUntil = action.payload.user.snoozeUntil;
      state.snoozeMuteChat = action.payload.user.snoozeMuteChat;
      state.snoozeMuteCalls = action.payload.user.snoozeMuteCalls;
      updateCallMuteState(state);
      break;
    }
    case UserTypes.TOGGLE_AUDIO_SUCCESS: {
      state.audio = action.payload.audio;
      updateCallMuteState(state);
      break;
    }
    case UserTypes.DISABLE_TCR_BANNER_SUCCESS: {
      state.remindOfTcrDeadline = action.payload.remindOfTcrDeadline;
      state.tcrBannerDismissedStep = action.payload.tcrBannerDismissedStep;
      break;
    }
    case UserTypes.PAUSE_NOTIFICATIONS_REQUEST: {
      const { snoozeUntil, muteChat, muteCalls } = action.meta;
      state.snoozeUntil = snoozeUntil;
      state.snoozeMuteChat = muteChat;
      state.snoozeMuteCalls = muteCalls;
      updateCallMuteState(state);
      break;
    }
    case UserTypes.PAUSE_NOTIFICATIONS_SUCCESS: {
      break;
    }
    case UserTypes.PAUSE_NOTIFICATIONS_FAILURE: {
      state.snoozeUntil = null;
      state.snoozeMuteChat = true;
      state.snoozeMuteCalls = true;
      updateCallMuteState(state);
      break;
    }
    case UserTypes.RESUME_NOTIFICATIONS_REQUEST: {
      state.snoozeUntil = null;
      state.snoozeMuteChat = true;
      state.snoozeMuteCalls = true;
      updateCallMuteState(state);
      break;
    }
    case UserTypes.RESUME_NOTIFICATIONS_SUCCESS: {
      break;
    }
    case UserTypes.RESUME_NOTIFICATIONS_FAILURE: {
      break;
    }
  }
}, initialState);
